/* eslint-disable @typescript-eslint/no-unused-vars */
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IGenericFormLoader } from '../../interfaces/form-label';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { differenceInCalendarDays } from 'date-fns';
import { DateTimeService } from '../../services/date-time.service';
import { DateFormat } from '../../interfaces/base-core-services.interface';
import { UserInfoService } from '../../services/user-info.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-approval',
  templateUrl: './ics-approval.html',
})
export class ICSApprovalComponent implements OnInit, IGenericFormLoader {
  public approvalStatusList:any[] = [];
  public rejectionReason:any[]= [];
  @Input() public defaultFormData:any;
  @Output() public submitedFormData = new EventEmitter<FormData>();
  public actions: string[] = [];
  public ICSApprovalForm: FormGroup;
  public aeoChecklistData = [];
  public checkListData:any[] = [];
  public AddCharges: boolean;
  public canSubmit = true;
  public actionReject = false;
  public appRemarks = false;
  public sBoxingDays = false;
  public addChargesView = false;
  public formData:any = [];
  public load = false;
  public rejectionOther = false;

  constructor(
    private formBuilder: FormBuilder,
    private dataTimeService: DateTimeService,
    private userInfo: UserInfoService
  ) {}

  ngOnInit():void  {
    if (typeof this.defaultFormData === 'object') {
      this.onLoad(this.defaultFormData);
      this.load = true;
    }
  }

  /**
   * A - Approval, R - Reject, M - MoreInfo
   * @param defaults | ARMC
   */
  onLoad(data:any):void  {
    if (this.defaultFormData.rdmData['ics-label-aeo-checklist']) {
      this.defaultFormData.rdmData['ics-label-aeo-checklist'].forEach(
        (element:any) => {
          const pickedObejct:any = _.pick(element, ['code', 'label']);
          pickedObejct['checked'] = false;
          this.checkListData.push(pickedObejct);
        }
      );
    }
    this.actions = this.prepareActions(data);
    this.ICSApprovalForm = this.formBuilder.group({
      approvalStatus: ['', [Validators.required]],
      rejectionOtherVal: [''],
      approvalRemarks: [''],
      internalRemarks: [''],
      rejectionReason: [''],
      sandBoxingDays: [''],
      endDate: [''],
      startDate: [''],
      comments: [''],
      sandboxDateType: ['days'],
    });


    const keys = Object.keys(data.rdmData);
    keys.forEach((key) => {
      if (key.indexOf('approval') >= 0) {
        this.approvalStatusList = data.rdmData[key];
      } else {
        const rejReason = data.rdmData[key];
        this.rejectionReason = rejReason.filter(
          (obj:any) => {
            return obj.label !== 'Others';
          }
        );
      }
    });
    // this.sBoxingDays = (data.extra === "number-of-days");

    if (this.checkListData.length == 0) this.canSubmit = false;
  }

  prepareActions(data: string): string[] {
    const actions:any = [];
    if (data && data.length > 0) {
      data.split(',').forEach((d) => {
        if (d.toLowerCase() === 'pfi') actions.push('Pending for Information');
        if (d.toLowerCase() === 'pfa') actions.push('Pending Final approval');
        if (d.toLowerCase() === 'a') actions.push('Approved');
        if (d.toLowerCase() === 'r') actions.push('Rejected');
      });
    }
    return actions;
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  log(val:any):void { }

  rejectionReasonChange(value: string):void  {
    const rejectionOtherVal:any = this.ICSApprovalForm.get('rejectionOtherVal');
    if (value == 'Others') {
      rejectionOtherVal.setValidators([Validators.required]);
      this.rejectionOther = true;
    } else {
      rejectionOtherVal.clearValidators();
      this.rejectionOther = false;
    }
  }
  sandBoxingTypeChange():void  {
    const startDate:any = this.ICSApprovalForm.get('startDate');
    const endDate:any = this.ICSApprovalForm.get('endDate');
    const sandBoxingDays:any = this.ICSApprovalForm.get('sandBoxingDays');
    if (this.ICSApprovalForm.controls.sandboxDateType.value === 'range') {
      startDate.setValidators([Validators.required]);
      endDate.setValidators([Validators.required]);
      sandBoxingDays.clearValidators();
    } else {
      sandBoxingDays.setValidators([Validators.required]);
      startDate.clearValidators();
      endDate.clearValidators();
    }
  }

  approvalStatusChange(value: string):void  {
    this.formData = { variables: {} };
    const aMarks:any = this.ICSApprovalForm.get('approvalRemarks');
    const rReason:any = this.ICSApprovalForm.get('rejectionReason');
    const rejectionOtherVal:any = this.ICSApprovalForm.get('rejectionOtherVal');
    const startDate:any = this.ICSApprovalForm.get('startDate');
    const endDate:any = this.ICSApprovalForm.get('endDate');
    const sandBoxingDays:any = this.ICSApprovalForm.get('sandBoxingDays');

    aMarks.setValue('');
    rReason.setValue('');
    rejectionOtherVal.setValue('');
    if (value.includes('Approval')) {
      this.appRemarks = true;
      this.actionReject = false;
      this.sBoxingDays = true;
      aMarks.setValidators([Validators.required]);
      rReason.clearValidators();
      rejectionOtherVal.clearValidators();
      startDate.clearValidators();
      endDate.clearValidators();
      sandBoxingDays.clearValidators();
    } else if (value.includes('Approved')) {
      this.appRemarks = true;
      this.actionReject = false;
      this.sBoxingDays = false;
      aMarks.setValidators([Validators.required]);
      startDate.clearValidators();
      endDate.clearValidators();
      rReason.clearValidators();
      sandBoxingDays.clearValidators();
      rejectionOtherVal.clearValidators();
    } else if (value.includes('Re-SandBoxing')) {
      this.appRemarks = true;
      this.actionReject = false;
      this.sBoxingDays = true;
      aMarks.setValidators([Validators.required]);
      rReason.clearValidators();
      rejectionOtherVal.clearValidators();
      this.sandBoxingTypeChange();
    } else if (value.includes('Rejected')) {
      this.actionReject = true;
      this.appRemarks = false;
      this.sBoxingDays = false;
      startDate.clearValidators();
      endDate.clearValidators();
      sandBoxingDays.clearValidators();
      rReason.setValidators([Validators.required]);
      aMarks.clearValidators();
    } else {
      this.actionReject = false;
      this.appRemarks = false;
      this.rejectionOther = false;
      this.sBoxingDays = false;
      startDate.clearValidators();
      endDate.clearValidators();
      sandBoxingDays.clearValidators();
      rReason.clearValidators();
      aMarks.clearValidators();
      rejectionOtherVal.clearValidators();
    }
  }

  isAddCharges(e:any) :void {
    this.AddCharges = !this.AddCharges;
  }

  updateSingleChecked(val:any):void  {
    if (_.filter(this.checkListData, ['checked', false]).length == 0) {
      this.canSubmit = false;
    } else {
      this.canSubmit = true;
    }
  }

  disabledStartDate = (current: Date): boolean => {
    const today = new Date();
    return differenceInCalendarDays(today, current) < 0;
  };

  disabledEndDate = (endDate: Date): boolean => {
    // const today = new Date();
    if (!endDate || !this.ICSApprovalForm.value.startDate) {
      return false;
    }
    return endDate.getTime() < this.ICSApprovalForm.value.startDate.getTime();
  };

  onStartDateChange(e:any): void {
    this.ICSApprovalForm.controls.endDate.reset();
  }

  onSubmit():void  {
    for (const i in this.ICSApprovalForm.controls) {
      if(i in this.ICSApprovalForm.controls){
        this.ICSApprovalForm.controls[i].markAsDirty();
        this.ICSApprovalForm.controls[i].updateValueAndValidity();
      }
    }
    if (this.checkListData.length > 0) {
      const aeoCheckListDataSeprated = _.map(
        _.filter(this.checkListData, ['checked', true]),
        'code'
      ).map((element) => {
        return element + '_' + 'true';
      });
      this.formData.variables['aeoCheckListString'] = {
        value: _.join(aeoCheckListDataSeprated, ','),
      };
    }
    if (this.ICSApprovalForm.value.approvalStatus.length > 0) {
      this.formData.variables['action'] = {
        value: this.ICSApprovalForm.value.approvalStatus,
      };
    }
    if (
      this.ICSApprovalForm.value.approvalRemarks.length > 0 &&
      this.appRemarks
    ) {
      this.formData.variables['approvalRemarks'] = {
        value: this.ICSApprovalForm.value.approvalRemarks,
      };
    }
    if (
      this.ICSApprovalForm.value.rejectionReason.length > 0 &&
      this.actionReject
    ) {
      if (this.rejectionOther) {
        this.formData.variables['rejectionReason'] = {
          value: this.ICSApprovalForm.value.rejectionOtherVal,
        };
      } else {
        this.formData.variables['rejectionReason'] = {
          value: this.ICSApprovalForm.value.rejectionReason,
        };
      }
    }
    if (this.ICSApprovalForm.value.internalRemarks.length > 0) {
      this.formData.variables['internalRemarks'] = {
        value: this.ICSApprovalForm.value.internalRemarks,
      };
    }
    if (this.ICSApprovalForm.value.sandBoxingDays > 0 && this.sBoxingDays) {
      this.formData.variables['sandBoxingDays'] = {
        value: this.ICSApprovalForm.value.sandBoxingDays,
      };
      this.formData.variables['endDate'] = {
        value: this.dataTimeService.getDateFormat(
          new Date(),
          DateFormat.YYYY_MM_DD
        ),
      };
      this.formData.variables['startDate'] = {
        value: this.dataTimeService.getDateFormat(
          this.dataTimeService.subtractDaysToDate(
            new Date(),
            this.ICSApprovalForm.value.sandBoxingDays
          ),
          DateFormat.YYYY_MM_DD
        ),
      };
    }

    if (this.ICSApprovalForm.value.startDate && this.sBoxingDays) {
      this.formData.variables['startDate'] = {
        value: this.dataTimeService.getDateFormat(
          this.ICSApprovalForm.value.startDate.getTime(),
          DateFormat.YYYY_MM_DD
        ),
      };
    }

    if (this.ICSApprovalForm.value.endDate && this.sBoxingDays) {
      this.formData.variables['endDate'] = {
        value: this.dataTimeService.getDateFormat(
          this.ICSApprovalForm.value.endDate.getTime(),
          DateFormat.YYYY_MM_DD
        ),
      };
    }

    if (
      this.ICSApprovalForm.value.endDate &&
      this.ICSApprovalForm.value.startDate &&
      this.sBoxingDays
    ) {
      this.formData.variables['sandBoxingDays'] = {
        value: differenceInCalendarDays(
          this.ICSApprovalForm.value.endDate,
          this.ICSApprovalForm.value.startDate
        ),
      };
    }
    this.formData.variables['actionBy'] = {
      value: this.userInfo.getUserName(),
    };

    if (this.ICSApprovalForm.valid) {
      console.log("this.formData", this.formData)
      this.submitedFormData.emit(this.formData);
    }
  }

  numberOnly(event:any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  addChargesChange(value:any):void  {}
}
